<template>
  <li :class="{ editing: editing }" class="todo">
    <div class="view">
      <input
        :checked="todo.done"
        class="toggle"
        type="checkbox"
        @change="toggleTodo( todo)"
      >
      <el-tooltip effect="dark" :content= showtext placement="top" :disabled="tooltipvalue" popper-class="atooltip">
         <label @dblclick="editing = true" v-text="todo.text" @mouseover="mouseover(todo.text)" style="max-width: 270px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"/>
      </el-tooltip>
      <!-- <button class="destroy" @click="deleteTodo( todo )" /> -->
    </div>
    <input
      v-show="editing"
      v-focus="editing"
      :value="todo.text"
      class="edit"
      @keyup.enter="doneEdit"
      @keyup.esc="cancelEdit"
      @blur="doneEdit"
    >
  </li>
</template>

<script>
export default {
  name: 'Todo',
  directives: {
    focus(el, { value }, { context }) {
      if (value) {
        context.$nextTick(() => {
          el.focus()
        })
      }
    }
  },
  props: {
    todo: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      editing: false,
      othertext: null,
      showtext: null,
      tooltipvalue: true
    }
  },
  methods: {
    deleteTodo(todo) {
      this.$emit('deleteTodo', todo)
    },
    editTodo({ todo, value }) {
      this.$emit('editTodo', { todo, value })
    },
    toggleTodo(todo) {
      this.$emit('toggleTodo', todo)
    },
    mouseover(todo){
      this.showtext = todo;
      if(todo.length > 18){
        this.tooltipvalue = false;
      }
    },
    doneEdit(e) {
      const value = e.target.value.trim()
      const { todo } = this
      if (!value) {
        this.deleteTodo({
          todo
        })
      } else if (this.editing) {
        this.editTodo({
          todo,
          value
        })
        this.editing = false
      }
    },
    cancelEdit(e) {
      e.target.value = this.todo.text
      this.editing = false
    }
  }
}
</script>
<style>
.atooltip{
      background: #515b62 !important;
      font-size:	12px;
      max-width:	330px;
  }
</style>>


